import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/league/record/list',
      data
    });
  }
};
